module.exports = __webpack_public_path__ + "static/media/pie.d70eea47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/AddGraph/pie.svg
// module id = 582
// module chunks = 0